import { render, staticRenderFns } from "./GlobalWarningDrawer.vue?vue&type=template&id=e59ace4a&scoped=true"
import script from "./GlobalWarningDrawer.vue?vue&type=script&lang=js"
export * from "./GlobalWarningDrawer.vue?vue&type=script&lang=js"
import style0 from "./GlobalWarningDrawer.vue?vue&type=style&index=0&id=e59ace4a&prod&scoped=true&lang=css"
import style1 from "./GlobalWarningDrawer.vue?vue&type=style&index=1&id=e59ace4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59ace4a",
  null
  
)

export default component.exports